// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindKeyQuality, TagKindKeyQuality } from "../schema";
import { serialize_KindKeyQuality_internal, deserialize_KindKeyQuality_internal } from "./KindKeyQuality";

export function serialize_TagKindKeyQuality_internal(value: TagKindKeyQuality): unknown {
  return ((value: { discriminator: KindKeyQuality; id: bigint; kind: KindKeyQuality }): unknown => {
    return {
      discriminator: ((value: KindKeyQuality): unknown => {
        return serialize_KindKeyQuality_internal(value);
      })(value["discriminator"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
      kind: ((value: KindKeyQuality): unknown => {
        return serialize_KindKeyQuality_internal(value);
      })(value["kind"]),
    };
  })(value);
}
export function serialize_TagKindKeyQuality(obj: TagKindKeyQuality): string {
  return renderJsonWithNumbersAsBigint(serialize_TagKindKeyQuality_internal(obj));
}
export function deserialize_TagKindKeyQuality_internal(value: unknown): ParserResult<TagKindKeyQuality> {
  return ((
    value: unknown,
  ): ParserResult<{
    discriminator: KindKeyQuality;
    id: bigint;
    kind: KindKeyQuality;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "discriminator")) {
      return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
    }
    const parsed_discriminator = ((): ParserResult<KindKeyQuality> => {
      return ((value: unknown): ParserResult<KindKeyQuality> => {
        return deserialize_KindKeyQuality_internal(value);
      })(value["discriminator"]);
    })();
    if (!parsed_discriminator.success) {
      return { success: false, reason: parsed_discriminator.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<KindKeyQuality> => {
      return ((value: unknown): ParserResult<KindKeyQuality> => {
        return deserialize_KindKeyQuality_internal(value);
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
  })(value);
}
export function deserialize_TagKindKeyQuality(str: string): ParserResult<TagKindKeyQuality> {
  return deserialize_TagKindKeyQuality_internal(parseJsonWithNumbersAsBigint(str));
}
